var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'person': true, 'normal': _vm.mode == 'normal', 'background': _vm.mode == 'background'}},[_c('img',{attrs:{"src":_vm.getPerson}})])}
var staticRenderFns = []

export { render, staticRenderFns }